<template>
  <div id="welcome">
    <WelcomeOA v-if="user.role_type === 'OA'" />
    <WelcomeLeader v-if="user.role_type === 'leader'" />
    <WelcomeMAM v-if="user.role_type === 'MAM'" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {
    WelcomeOA: () => import(/* webpackChunkName: "dashboard-oa" */ './WelcomeOA.vue'),
    WelcomeLeader: () => import(/* webpackChunkName: "dashboard-leader" */ './WelcomeLeader.vue'),
    WelcomeMAM: () => import(/* webpackChunkName: "dashboard-mam" */ './WelcomeMAM.vue'),
  },

  computed: mapState({
    user: (state) => state.user.user,
  }),

  watch: {
    user: {
      handler(newValue) {
        if (newValue.role_type === 'coach' && !['calendar', 'calendarToDate'].includes(this.$route.name)) {
          this.$router.push({ name: 'calendar' });
        }
      },
    },
  },
};
</script>
